'use client';

import { usePathname } from 'next/navigation';

import { toMountedPath } from '@/lib/routing/host-router';
import { currentPlatformHost } from '@/lib/routing/platform-hosts';

/**
 * `usePathname()`, expressed the way the app's route tables describe routes.
 *
 * On a host-based deployment the browser's pathname is host-relative:
 * dashboard.menuraq.com reports `/analytics`, not `/dashboard/analytics`. Every
 * route table, guard and active-state check in this codebase is written against the
 * mounted form, so matching the raw pathname silently matches nothing — the guard
 * stops guarding, the breadcrumb empties, the nav item stops highlighting.
 *
 * That failure has now appeared four times (the proxy POS gate, ProtectedRoute, the
 * cookie banner, and the dashboard chrome). Any component that MATCHES a pathname
 * should use this; anything that builds a link should keep the raw value.
 *
 * A no-op on www, in dev and on previews, which are already path-based.
 */
export function useMountedPathname(): string {
  const pathname = usePathname();
  return toMountedPath(pathname ?? '/', currentPlatformHost());
}
